import LogoutIcon from "@mui/icons-material/Logout";

const Logout = (props: any) => {
  return <LogoutIcon {...props} />;
};

export default Logout;
